import axios from 'axios'
import qs from 'qs'
import store from '@/store/index'
import { getToken, removeToken } from '@/utils/auth'

export function getUrl() {
  return store.state.app.site + '/index.php'
}

/**
 * @description 发送ajax请求
 * @param {object} params 请求参数
 * @param {string} params.url 请求地址
 * @param {object} params.data 请求数据
 * @param {function} params.ajaxfn 成功回调
 * @param {function} params.rejectfn 失败回调
 * @param {import('axios').CancelToken} params.cancelToken 取消 token
 */
export default function ajax(params) {
  let { url } = params
  const { data = {}, ajaxfn, rejectfn, cancelToken } = params
  let token = getToken()
  if (url == '/login') {
    token = ''
  }
  if (url.slice(0, 4) != 'http') {
    url = getUrl() + url
  }
  const fullURL = `${url}${token ? '?token=' + token : ''}`
  axios({
    method: 'POST',
    url: fullURL,
    data: qs.stringify(data),
    cancelToken
  })
    .then(function(res) {
      if (res.data.status == 195) {
        window.$vm.$message({
          message: res.data.msg,
          type: 'info'
        })
        removeToken()
        setTimeout(() => {
          location.reload()
        }, 1000)
        return
      }
      if (res.data.status == -1) {
        window.$vm.$message({
          type: 'info',
          message: res.data.msg
        })
        rejectfn?.(res)
        return
      }
      if (res.data.status == -2) {
        window.$vm.$message({
          type: 'info',
          message: res.data.msg
        })
        rejectfn?.(res)
        return
      }
      ajaxfn(res)
    })
    .catch((res) => {
      // 取消错误
      if (axios.isCancel(res)) {
        console.log('请求取消', res.message)
        rejectfn?.(res)
        return
      }
      window.$vm.$message({
        type: 'info',
        message: '网络连接请求失败,请稍后重试'
      })
      console.error(res)
      rejectfn?.(res)
    })
}

export function ajax_file({ url, data = {}, _this, ajaxfn }) {
  if (!_this) {
    _this = window.$vm
  }
  let token = getToken()
  if (url == '/login') {
    token = ''
  }
  axios({
    method: 'POST',
    url: getUrl() + url + (token ? '?token=' + token : ''), // + (process.env.NODE_ENV == 'development' ? '?token=' + token : '')
    data
  })
    .then(function(res) {
      if (res.data.status == 195) {
        window.$vm.$message({
          message: res.data.msg,
          type: 'info'
        })
        removeToken()
        setTimeout(() => {
          location.reload()
        }, 1000)
        return false
      }
      if (res.data.status == -1) {
        window.$vm.$message({
          type: 'info',
          message: res.data.msg
        })
        return false
      }
      if (res.data.status == -2) {
        window.$vm.$message({
          type: 'info',
          message: res.data.msg
        })
        return false
      }
      ajaxfn(res)
    })
    .catch(function(res) {
      window.$vm.$message({
        type: 'info',
        message: '网络连接请求失败,请稍后重试'
      })
    })
}

export function login(data, fn) {
  ajax({
    url: '/login',
    data,
    ajaxfn: function(res) {
      fn(res)
      window.$vm.$router.push({ path: '/index/body1' })
    }
  })
}
export function get_code(data) {
  ajax({
    url: '/verifi',
    data,
    ajaxfn: function(res) {
      console.log(res)
    }
  })
}
export function getmerchant_list(data, fn) {
  ajax({
    url: '/merchant/get_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getwxupdate_list(data, fn) {
  ajax({
    url: '/wxupdate/getlist',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function commit(data, fn) {
  ajax({
    url: '/wxupdate/commit',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function submit_audit(data, fn) {
  ajax({
    url: '/wxupdate/submit_audit',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function add_merchant(data, fn) {
  ajax({
    url: '/merchant/add',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_code_status(data, fn) {
  ajax({
    url: '/merchant/query_creat_order_status',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_create_store_order(data, fn) {
  ajax({
    url: '/merchant/get_creat_store_order',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function getorder_list(data, fn) {
  ajax({
    url: '/merchant/order_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function changeOrder_status(data, fn) {
  ajax({
    url: '/merchant/editor_order_status',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function pay_upload(data, fn) {
  ajax({
    url: '/merchant/order_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function application(data, fn) {
  ajax({
    url: '/pay/application',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function pay_list(data, fn) {
  ajax({
    url: '/pay/get_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function get_details(data, fn) {
  ajax({
    url: '/pay/get_details',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function levelup(data, fn) {
  ajax({
    url: '/pay/levelup',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function getaccountbasicinfo(data, fn) {
  ajax({
    url: '/miniapp/getaccountbasicinfo',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getallcategories(data, fn) {
  ajax({
    url: '/miniapp/getallcategories',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function getcategory(data, fn) {
  ajax({
    url: '/miniapp/getcategory',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function memberauth(data, fn) {
  ajax({
    url: '/miniapp/memberauth',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function modifyheadimage(data, fn) {
  ajax({
    url: '/miniapp/modifyheadimage',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function checkwxverifynickname(data, fn) {
  ajax({
    url: '/miniapp/checkwxverifynickname',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function setnickname(data, fn) {
  ajax({
    url: '/miniapp/setnickname',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function addcategory(data, fn) {
  ajax({
    url: '/miniapp/addcategory',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function add_memberauth(data, fn) {
  ajax({
    url: '/miniapp/add_memberauth',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function modifysignature(data, fn) {
  ajax({
    url: '/miniapp/modifysignature',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function unbind_tester(data, fn) {
  ajax({
    url: '/miniapp/unbind_tester',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function deletecategory(data, fn) {
  ajax({
    url: '/miniapp/deletecategory',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function get_colorlist(data, fn) {
  ajax({
    url: '/design/colourList',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_label(data, fn) {
  ajax({
    url: '/merchant/add_label',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_color(data, fn) {
  ajax({
    url: '/design/addColour',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function bind_label(data, fn) {
  ajax({
    url: '/merchant/bind_store',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_color(data, fn) {
  ajax({
    url: '/design/delColour',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function edit_label(data, fn) {
  ajax({
    url: '/merchant/editLabel',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function change_color_sort(data, fn) {
  ajax({
    url: '/design/changeColourSort',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_label(data, fn) {
  ajax({
    url: '/merchant/delLabel',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function template_list(data, fn) {
  ajax({
    url: '/design/templateList',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function dellabel(data, fn) {
  ajax({
    url: '/merchant/del_label',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function homemade_list(data, fn) {
  ajax({
    url: '/design/designList',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_homemade(data, fn) {
  ajax_file({
    url: '/design/addDesign',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function edit_homemade(data, fn) {
  ajax({
    url: '/design/editDesign',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_homemade(data, fn) {
  ajax({
    url: '/design/delDesign',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_template(data, fn) {
  ajax_file({
    url: '/design/addTemplate',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function edit_template(data, fn) {
  ajax_file({
    url: '/design/editTemplate',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_template(data, fn) {
  ajax({
    url: '/design/delTemplate',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function icon_list(data, fn) {
  ajax({
    url: '/icon/get_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_group(data, fn) {
  ajax({
    url: '/icon/save_group',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_group(data, fn) {
  ajax({
    url: '/icon/del_group',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function add_icon(data, fn) {
  ajax({
    url: '/icon/save_icon',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function del_icon(data, fn) {
  ajax({
    url: '/icon/del_icon',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

export function editlabel(data, fn) {
  ajax({
    url: '/merchant/edit_label',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
export function settlement_bill_list(data, fn) {
  ajax({
    url: '/withdraw_record/get_agent_settlement_cycle',
    data: data,
    ajaxfn: res => {
      fn(res)
    }
  })
}

// 角色列表
export function get_worker_permission_list(data, fn) {
  ajax({
    url: '/worker/get_worker_permission_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

// 删除角色
export function del_worker_permission(data, fn) {
  ajax({
    url: '/worker/del_worker_permission',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

// 修改和添加角色
export function save_worker_permission(data, fn) {
  ajax({
    url: '/worker/save_worker_permission',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

// 解除绑定员工
export function cancel_worker_permission(data, fn) {
  ajax({
    url: '/worker/cancel_worker_permission',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

// 绑定员工
export function bind_worker_permission(data, fn) {
  ajax({
    url: '/worker/bind_worker_permission',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}

// 员工列表
export function get_worker_list(data, fn) {
  ajax({
    url: '/worker/get_worker_list',
    data,
    ajaxfn: function(res) {
      fn(res)
    }
  })
}
